import styled from 'styled-components/macro';

export default styled.div`
.MuiDataGrid-columnHeaders{
    .MuiDataGrid-columnHeaderTitle{
        font-weight:bold;
    }
}
`